import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { channels_dictionary } from '../../static/channels_dictionary';
import { findGateInUser, handleChannelClick } from '../utilsDesign';
import { Avatar } from './Avatar';
import { AvatarName } from './AvatarName';
import { GateAllActivations } from './GateAllActivations';
import GateNumber from './GateNumber';
import { Txt } from './Txt';
import { Videos } from './Videos';
import { VideoIco } from './VideoIco';
import { GateInfo } from './GateInfo';
import { TooltipH } from './TooltipH';
import { Icon } from './Icon';
import ChannelFocused from './ChannelFocused';


export const Channel = React.memo((props) => {


  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;
  const $channel = context.$channel;

  const {
    uniq = '',
    id,
    label = false,
    centers = [],
    circuit = '',
    type = [],
    // gates = [],
    title = '',
    design = {},
    description = true,
    stream = '',
    activatedWith = {},
    className,
    owner,
    penta,
    showBodygraph = false,
    showActivations,
    showAdvancedInfo,
    videos = 'inline', //'ico',
    view = 'column', //'line'
    hideLabel = false,
    hideTitle = false,
    hideTitleMobile = false,
    hideNumbers = false,
    gateInfo = false,
    visual = 'default',
    channels = []
  } = { ...props };


  const gates = id.split('-');
  const gateNumbers = gates.map(one => parseInt(one));

  const location = useLocation();
  const navigate = useNavigate();

  const handleChannelClickInner = (channelId) => {
    const centers = channels_dictionary.filter(one => one.id === channelId)[0].centers;
    const gates = channels_dictionary.filter(one => one.id === channelId)[0].gates;
    context.setState.setHighlighted([...centers]);
    context.setState.setSearch([...gates]);
    handleChannelClick(channelId, location, navigate);
  };


  // const gates = design.gates ;

  return (
    <>



      <div className={`x_edu_chan ${className ? className : ''} x_edu_chan--${visual} x_edu_chan--length${channels.length}`}

        onClick={(e) => {
          e.stopPropagation();
          // if (!penta) {
          handleChannelClickInner(id)
          // }
        }}
      >



        <div className="x_edu_channel_title00">




          {label && <><div className="x_edu_content_label">
            {$ui('channel')}
          </div></>}



          <div
            className={`x_edu_channel_info x_edu_channel_info--${visual} ${location.pathname.includes(`channel:${id}`) ? 'active' : ''} `}
          // className={location.pathname.includes(`channel:${id}`) ? "x_edu_channel_info active" : "x_edu_channel_info"}
          >

            {showBodygraph && <div className="x_channel_info_preview">
            <ChannelFocused
              design={design}
              highlightedGate={gateNumbers}
              style={{ width: '100%', height: '8em' }}
            /></div>}

            <div className={`x_edu_channel_title0 ${view === 'line' ? 'x_edu_channel_info_inner--line' : ''}`}>

              {/* <div className="x_edu_channel_more"><div className="t_icon t_icon--60">
              {!shown && <div>arrow_drop_down</div>}
              {shown && <div>arrow_drop_up</div>}
            </div></div> */}


              <div className="x_edu_channel_info_top">

                <div className="x_edu_channel_title0">

                  {/* <span className="x_edu_channel_nums">
                <GateNumber design={design} gateId={gates[0]} />
                <GateNumber design={design} gateId={gates[1]} />
              </span> */}


                  <div className="x_edu_channel_title">
                    {!hideNumbers && <span className="x_edu_channel_nums0">
                      <span className="x_edu_channel_nums">
                        <GateNumber design={design} gateId={gates[0]} />
                        <GateNumber design={design} gateId={gates[1]} />
                      </span>
                    </span>}&nbsp;&nbsp;
                    {!hideLabel && <span className={`x_edu_channel_h1 x_edu_channel_of _tnowrap ${hideTitleMobile ? 'hide_title_mobile' : ''}`}>{$ui('channel_of')}</span>} {!hideTitle && <span className={`x_edu_channel_h1 ${hideTitleMobile ? 'mobile_vh_no' : ''}`}>{$channel(id, 'title')}</span>}

                    {videos === 'ico' && <VideoIco>
                      <Videos
                        title={`${gates[0]}–${gates[1]} ${$channel(id, 'title')}`}
                        size='sm'
                        relType='channels'
                        relValue={id}
                      />
                    </VideoIco>}


                  </div>


                </div>




              </div>

            



            </div>

            {description && <div className="x_edu_item_desc">
                  <Txt>{$channel(id, 'description')}</Txt>
                </div>}


                {showAdvancedInfo && <ChannelTypeInfo
                  {...props}
                />}



              {/* <div className="x_edu_channel_info_more0"
              onClick={() => setShown(!shown)}
            >
              <div className="t_icon t_icon--20">
                {!shown && <div>expand_more</div>}
                {shown && <div>expand_less</div>}
              </div>
            </div> */}


              {design
                && design.gates
                && showActivations
                && <div
                  // style={{ marginLeft: '-0.8em' }}
                  className={`x_edu_activatedby ${view === 'line' ? 'x_edu_activatedby--line' : ''} inactive`}>
                  <div>
                    <GateAllActivations
                      number={true}
                      hexagram={true}
                      design={design}
                      gateId={gates[0]} />
                  </div>
                  <div>
                    <GateAllActivations
                      number={true}
                      hexagram={true}
                      design={design}
                      gateId={gates[1]} />
                  </div>
                </div>}

              {videos === 'inline' && <Videos
                title={`${gates[0]}–${gates[1]} ${$channel(id, 'title')}`}
                size='sm'
                relType='channels'
                relValue={id}
              />}

              {penta && (
                <ChannelPentaActivations
                  penta={penta}
                  gates={gates}
                  gateInfo={gateInfo}
                  view={view}
                />
              )}




          </div>


        </div>







        {/* <div className={showActivations ? "x_edu_planets active" : "x_edu_planets"}>
          <div className={showActivations ? "x_edu_planets_inner active" : "x_edu_planets_inner"}>


            <div className="x_edu_activations_type">


              <ChannelTypeInfo
                type={type}
                circuit={circuit}
                stream={stream}
              />


              <Videos
                title={`${gates[0]}–${gates[1]} ${$channel(id, 'title')}`}
                size='sm'
                relType='channels'
                relValue={id} />

            </div>






            <div className="x_edu_labels">
            <div className="x_edu_planets_title">
              <div>Center</div>
            </div>
            <div className="x_edu_gate_label">
              <div>Gate</div>
            </div>
            <div className="x_edu_gate_label">
              <div>Defined by</div>
            </div>
            </div>
            {gates[0] && gates[0]['planet'] && <div className="x_edu_pl1">
              <div className="x_edu_planets_title">
                {getCenter([centers[0]], 'title')}
              </div>
              <GateOne gateNumber={gates[0]} design={design} shown={shown} uniq={`${uniq}`} />

            </div>}
            {gates[1] && gates[1]['planet'] && <div className="x_edu_pl1">
              <div className="x_edu_planets_title">
                {getCenter([centers[1]], 'title')}
              </div>
              <GateOne gateNumber={gates[1]} design={design} shown={shown} uniq={`${uniq}`} />
            </div>}
          </div>
        </div> */}
      </div>


    </>
  );
});



/** Per-member activations for a penta/composite: name, then that person's planets. */
export function ChannelPentaActivations({
  penta,
  gates = [],
  gateInfo = false,
  view = 'column',
  number = true,
  hexagram = true,
  planets = false,
  stack = false,
}) {
  if (!penta?.members?.length || !gates.length) return null;

  const gateIds = gates.map((g) => String(g));
  const memberCount = penta.members.length;

  return (
    <div
      className={`x_edu_activatedby ${view === 'line' ? 'x_edu_activatedby--line' : ''} ${stack ? 'x_edu_activatedby--penta_stack' : ''} inactive`}
    >
      {penta.members.map((one) => {
        const design = one.avatar?.design;
        if (!design?.gates) return null;

        const activeGates = gateIds.filter((gateId) =>
          Boolean(findGateInUser(design.gates, gateId).length)
        );
        if (!activeGates.length) return null;

        return (
          <div
            className="x_edu_penta_channel_activation"
            key={`channel_${one.avatar.token}`}
            style={stack ? undefined : {
              flexBasis: `calc(${(100 / memberCount)}% - 0.5em)`,
              maxWidth: `calc(${(100 / memberCount)}% - 0.5em)`,
            }}
          >
            <div className={`x_ava_inline_name x_ava_inline_name--${(design.type || '').toLowerCase()}`}>
              <div className="x_avatar_1line">
                <AvatarName avatar={one.avatar} />
              </div>
            </div>

            {activeGates.map((oneGateId) => (
              <div key={`gate_${oneGateId}`} className="x_edu_gate_activation">
                {!gateInfo && (
                  <GateAllActivations
                    number={number}
                    hexagram={hexagram}
                    planets={planets}
                    design={design}
                    gateId={oneGateId}
                  />
                )}
                {gateInfo && (
                  <GateInfo
                    design={design}
                    number={true}
                    hexagram={true}
                    title={true}
                    planets={true}
                    description={false}
                    gateId={oneGateId}
                    visual="min"
                  />
                )}
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}

export function ChannelTypeInfo({
  types = [],
  circuit,
  stream,
  className = '',
  page
}) {

  const uniq = ''
  const context = { ...useContext(LangContext) };
  const $ui = context.$ui;
  const circuitLabel = Array.isArray(circuit) ? circuit.map(one => $ui(one)).join(', ') : circuit ? $ui(circuit) : '';
  const streamLabel = Array.isArray(stream) ? stream.map(one => $ui(one)).join(', ') : stream ? $ui(stream) : '';

  return (
    <>
      {/* <div className={`x_channel_typeinfo ${className ? className : ''}`}> */}
      <div className={`x_channel_typeinfo`}>
        {
        // !page ||  page !== 'types' && 
        Boolean(types?.length) && <div>
          {$ui('type')}: <strong>{types.map(oneType => $ui(oneType)).join(', ')}</strong>
          {/* {$ui('type')}: <strong>{type.map(oneType => oneType)}</strong> */}
        </div>}
        {
        // !page || page !== 'circuit' && 
        Boolean(circuitLabel) && <div className=''>{$ui('circuit')}: <strong>{circuitLabel}</strong></div>}
        {Boolean(streamLabel) && <div className=''>{$ui('sub_circuit')}: <strong>{streamLabel}</strong></div>}
      </div>
    </>
  )
}

export default Channel
